import { Button, DatePicker, DropdownSelect } from '@components/common';
import { RefreshCcw } from 'lucide-react';
import React from 'react';
import {
  INVENTORY_DASHBOARD_PERIOD_OPTIONS,
  InventoryDashboardPeriodPreset,
} from './inventoryDashboard';

interface InventoryDashboardToolbarProps {
  scopeLabel: string;
  preset: InventoryDashboardPeriodPreset;
  dateFrom: string;
  dateTo: string;
  isRefreshing: boolean;
  onPresetChange: (value: InventoryDashboardPeriodPreset) => void;
  onDateFromChange: (value: string) => void;
  onDateToChange: (value: string) => void;
  onRefresh: () => void;
}

export function InventoryDashboardToolbar({
  scopeLabel,
  preset,
  dateFrom,
  dateTo,
  isRefreshing,
  onPresetChange,
  onDateFromChange,
  onDateToChange,
  onRefresh,
}: InventoryDashboardToolbarProps) {
  return (
    <div className="rounded-[22px] border border-gray-200 bg-white p-3.5 shadow-sm">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-pos-primary">
            Inventory overview
          </p>
          <h2 className="mt-1 text-lg font-semibold tracking-tight text-slate-950">
            Stock health and purchasing activity
          </h2>
          <p className="mt-1 text-sm text-slate-500">{scopeLabel}</p>
        </div>

        <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-[190px_150px_150px_auto]">
          <DropdownSelect
            label="Period"
            value={preset}
            options={INVENTORY_DASHBOARD_PERIOD_OPTIONS.map((option) => ({
              value: option.value,
              label: option.label,
            }))}
            onChange={(value) =>
              onPresetChange(value as InventoryDashboardPeriodPreset)
            }
          />
          <DatePicker
            label="From"
            mode="single"
            value={dateFrom}
            onChange={onDateFromChange}
            placeholder="Select start date"
          />
          <DatePicker
            label="To"
            mode="single"
            value={dateTo}
            onChange={onDateToChange}
            placeholder="Select end date"
          />
          <div className="flex items-end">
            <Button
              variant="outline"
              className="w-full"
              onClick={onRefresh}
              disabled={isRefreshing}
            >
              <RefreshCcw size={16} className="mr-2" />
              {isRefreshing ? 'Refreshing...' : 'Refresh'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
